import { useQuery } from "react-query";
import axios from "axios";

const getCompany = async ({ companyId, companyName }) => {
  if (companyId) {
    const { data: company } = await axios.get(`/api/v2/companies/${companyId}`);
    return company;
  } else if (companyName) {
    const { data: company } = await axios.get(
      `/api/v2/companies/name/${companyName}`
    );

    return company;
  }
};

export default function useCompany({ companyId, companyName }) {
  let companyKey = companyId;
  if (!companyKey) {
    companyKey = companyName;
  }

  // console.log("companyKey", companyKey);

  return useQuery(
    ["companies", companyKey],
    () => getCompany({ companyId, companyName }),
    {
      enabled: companyId !== undefined || companyName !== undefined,
    }
  );
}
